// Staging isolation: when the SPA is served under /test/ (see
// docs/deployment-staging.md), installStagingFetch() monkey-patches
// window.fetch to rewrite trip + share + profile API paths from /api/tp/... to
// /api/tp-test/... so staging reads/writes the trips_test collection and
// can never mutate production itineraries. Non-trip helper APIs
// (images, AI, flights, scan) intentionally stay on production paths.
// Trailing slash matters: a bare '/api/tp/share' prefix also matches
// '/api/tp/share-target/...' (the PWA share-target redemption route, which
// is intentionally NOT collection-scoped — see server/index.js), silently
// rewriting it to a path that was never registered under /api/tp-test/ and
// 404ing. The slash forces a real path-segment boundary.
const API_REWRITES = [
  ['/api/tp/trips', '/api/tp-test/trips'],
  ['/api/tp/share/', '/api/tp-test/share/'],
  ['/api/tp/profile', '/api/tp-test/profile'],
];

export function isStagingPath(pathname = window.location.pathname) {
  return pathname === '/test' || pathname.startsWith('/test/');
}

export function rewriteStagingTripApi(input, pathname = window.location.pathname) {
  if (!isStagingPath(pathname)) return input;

  if (typeof input === 'string') {
    for (const [from, to] of API_REWRITES) {
      if (input.startsWith(from)) return `${to}${input.slice(from.length)}`;
    }
    return input;
  }

  if (input instanceof URL) {
    for (const [from, to] of API_REWRITES) {
      if (input.pathname.startsWith(from)) {
        const copy = new URL(input.toString());
        copy.pathname = `${to}${copy.pathname.slice(from.length)}`;
        return copy;
      }
    }
    return input;
  }

  if (typeof Request !== 'undefined' && input instanceof Request) {
    const url = new URL(input.url);
    for (const [from, to] of API_REWRITES) {
      if (url.pathname.startsWith(from)) {
        url.pathname = `${to}${url.pathname.slice(from.length)}`;
        return new Request(url.toString(), input);
      }
    }
    return input;
  }

  return input;
}

export function installStagingFetch() {
  if (typeof window === 'undefined' || window.__travelPlannerStagingFetchInstalled) return;
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => originalFetch(rewriteStagingTripApi(input), init);
  window.__travelPlannerStagingFetchInstalled = true;
}
